import React, { useState, useEffect } from "react";
import {
  useDispatch, useSelector
} from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { 
  fetchClientsStart, 
  fetchReferrals, 
  unlinkClients 
} from "store/client/actions";
import Select from "react-select";

function unLinkClients({ clientId, t }) {
  const dispatch = useDispatch();
  const { linking } = useSelector((state) => state.clientReducer);
  const { referrals } = useSelector((state) => state.clientReducer?.clientDetails);
  const { agreements } = useSelector((state) => state.ibAgreements);
  const allClients = useSelector((state) =>  state.clientReducer.clients || []);
  // const [ownClients, setOwnClients] = useState([]);
  const [agreementClients, setAgreementClients] = useState([]);
  const [selectedAgreement, setSelectedAgreement] = useState(null);
  useEffect(() => {
    dispatch(fetchReferrals({
      type: "live",
      clientId: clientId
    }));
  }, [clientId]);

  const [linkClientModal, setLinkClientModal] = useState(false);

  // useEffect(() => {
  //   if (referrals && referrals[0].childs ) {
  //     const children = referrals[0].childs;
  //     const ownClients = children.filter(client => !client?.childs || client?.childs?.length === 0);
  //     setOwnClients(ownClients.filter(client =>  !client?.fx?.isIb));
  //   }
  // }, [referrals]);

  const toggleModal = () => {
    setLinkClientModal(!linkClientModal);
  };

  useEffect(() => {
    if (linking && linkClientModal) {
      setLinkClientModal(false);
    }
  }, [linking]);

  useEffect(() => {
    loadClients();
  }, []);

  const loadClients = () => {
    dispatch(
      fetchClientsStart({
        limit: 10000,
      })
    );
  };
  return (
    <React.Fragment >
      <button
        type="button"
        className="btn btn-primary waves-effect waves-light w-100 me-1"
        onClick={toggleModal}
      >
        {t("Unlink Clients")}
      </button>
      <Modal isOpen={linkClientModal} toggle={toggleModal} centered={true}>
        <ModalHeader toggle={toggleModal} tag="h4">
          {t("Unlink Clients")}
        </ModalHeader>
        <ModalBody >
          <AvForm
            className='px-4'
            onValidSubmit={(e, v) => {
              const ownClientsIds = agreementClients.map((client) => client._id);
              v.clientIds = ownClientsIds;
              dispatch(unlinkClients(v));
            }}
          >
            <div className="row my-2">
              <label>{t("Select Agreement")}</label>
              <Select
                className="w-full"
                name="agreement"
                onChange={(e) => {
                  setSelectedAgreement(e.value);
                  setAgreementClients(
                    allClients.filter((client) => client.fx.agrementId === e.value)
                  );
                }}
                value={selectedAgreement === null ? "" : undefined}
                options={agreements?.map((agreement) => {
                  return {
                    label: agreement.title,
                    value: agreement._id,
                  };
                })}
              />
            </div>
            {selectedAgreement ? (
              agreementClients.length !== 0 ? (
                <AvField
                  multiple
                  type="select"
                  name="clientIds"
                  label={t("Clients")}
                >
                  {agreementClients.map((client) => (
                    <option key={client._id} value={client._id}>
                      {client.firstName} {client.lastName}
                    </option>
                  ))}
                </AvField>
              ) : (
                <h6 className="text-center">{t("No clients for this Agreement")}</h6>
              )
            ) : null}

            {agreementClients.length !== 0 && selectedAgreement && <div className='text-center mt-3'>
              <Button type="submit" color="primary">
                {t("Unlink")}
              </Button>
            </div>}
          </AvForm>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}

export default withTranslation()(unLinkClients);